import { AITissueModel } from 'components/AITools/models/AITissueModel';

export class AIAiraModel extends AITissueModel {
  getModelOpacity() {
    return super.getOpacity().aira;
  }
}
